const UpdateOrderFields = {
    'ADDRESS': 'address',
    'ITEM': 'item',
    'QUANTITY': 'quantity',
    'ADDITEM': 'addItem',
    'ADDQUANTITY': 'addQuantity',
    'DELETEITEM': 'deleteItem'
};

export {
    UpdateOrderFields
};